import React from "react";
import { Link, useParams } from "react-router-dom";
import ScrollReveal from "@/components/ScrollReveal/ScrollReveal";

const POSTS = [
  {
    slug: "coffito-414-2012",
    title: "COFFITO 414/2012: o que todo fisioterapeuta precisa saber sobre prontuário",
    tag: "Regulatório",
    date: "Jun 2026",
    excerpt: "A resolução que ninguém leu, mas todos precisam cumprir. Um guia direto sobre os campos obrigatórios, riscos de perícia e como organizar a documentação clínica.",
  },
  {
    slug: "ia-voz-documentacao-clinica-brasil",
    title: "Como a IA de voz está mudando a documentação clínica no Brasil",
    tag: "Tecnologia",
    date: "Jun 2026",
    excerpt: "De Whisper a Gemini: por que 2026 é o ano em que prontuários ditados deixam de ser ficção científica para fisioterapeutas brasileiros.",
  },
  {
    slug: "45-minutos-custo-oculto-documentacao",
    title: "45 minutos por dia: o custo oculto da documentação manual em fisioterapia",
    tag: "Produtividade",
    date: "Mai 2026",
    excerpt: "Quanto vale o tempo perdido com papelada? Calculamos o impacto em receita e qualidade de vida para um fisioterapeuta brasileiro médio.",
  },
];

export default function BlogPage() {
  const { slug } = useParams();
  const post = slug ? POSTS.find((p) => p.slug === slug) : null;

  if (slug) {
    return (
      <section className="page-intro" data-testid="blog-post">
        <div className="container">
          <ScrollReveal>
            <Link to="/blog" className="link-accent" style={{ marginBottom: 24 }} data-testid="blog-back">
              ← Voltar ao blog
            </Link>
            <span className="eyebrow" style={{ marginTop: 24 }}>
              {post?.tag || "Em breve"}
            </span>
            <h1 className="h-1">{post?.title || "Em breve"}</h1>
            <p className="body-lg page-intro-sub">
              Estamos finalizando este artigo. Em breve disponível aqui.
            </p>
            <div style={{ marginTop: 40 }}>
              <Link to="/blog" className="btn btn-ghost" data-testid="blog-back-cta">
                Ver outros artigos
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="page-intro" data-testid="page-intro">
        <div className="container">
          <ScrollReveal>
            <span className="eyebrow">BLOG</span>
            <h1 className="h-1">Ideias, dados e prática clínica</h1>
            <p className="body-lg page-intro-sub">
              Conteúdo prático sobre documentação, regulação e o uso de IA na
              fisioterapia brasileira.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-surface" data-testid="section-blog-list">
        <div className="container">
          <div className="blog-grid">
            {POSTS.map((p, i) => (
              <ScrollReveal key={p.slug} delay={i * 0.08}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}>
                  <article className="glass blog-card glass-hover">
                    <span className="blog-tag">{p.tag}</span>
                    <h2 className="blog-card-title">{p.title}</h2>
                    <p className="blog-card-excerpt">{p.excerpt}</p>
                    <span className="blog-card-meta">{p.date}</span>
                  </article>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
